/**
 * Created by Alican Köker on 2019-01-22.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {EdisonGameConfig} from "../../EdisonGameConfig";
import {EdisonGameModuleConfig} from "../../EdisonGameModuleConfig";
import {EdisonSoundConfig} from "../../EdisonSoundConfig";
import {EdisonStateReelSymbol} from "../../reel/reelSymbol/EdisonStateReelSymbol";
import {EdisonParsedGameData} from "../../server/data/EdisonParsedGameData";

export class EdisonRandomFeatureController extends BaseController {

    private _gameData:EdisonParsedGameData;
    private _featureTriggered:boolean = false;
    public static readonly RANDOM_FEATURE_TRIGGERED:string = "edisonReelStopPresentationController_randomFeatureTriggered";

    constructor() {
        super();

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ReelEvent.REEL_STOP_SPIN_STARTED, (event:GameEvent) => this.onStopSpinStarted(event.params[0]));
    }

    protected onGameDataParsed(data:EdisonParsedGameData):void {
        this._gameData = data;
        this._featureTriggered = this._gameData.randomM1WildModeTriggeredThisSpin || this._gameData.randomM2WildModeTriggeredThisSpin;
        let featureSym:string = this._gameData.randomM1WildModeTriggeredThisSpin ? "M1" : "M2";

        EventHandler.dispatchEvent(new GameEvent(EdisonRandomFeatureController.RANDOM_FEATURE_TRIGGERED, this._featureTriggered));

        if(this._featureTriggered) {
            let tl:TimelineLite = new TimelineLite();
            tl.add(() => {
                EdisonGameModuleConfig.featureController.startRandomFeaturePresentation(featureSym);
            }, .5);
            tl.add(() => {
                EdisonGameModuleConfig.featureController.finishRandomFeaturePresentation();
            }, 2);
            tl.add(() => {
                SlotGame.sound.playEffect(EdisonSoundConfig.instance.FS_ANTICIPATION);
            }, 2);
        }
    }

    private onStopSpinStarted(reelId:number):void {
        if(this._featureTriggered)
            this.turnSymbolsToGold(reelId);
    }

    public turnSymbolsToGold(reelId:number):void {

        let reel:ReelController | null = Reels.getReel(reelId);

        if(reel) {
            reel.allSymbols.forEach((symbol) => {
                if(symbol) {
                    if(symbol.symName === "M1" && this._gameData.randomM1WildModeTriggeredThisSpin) {
                        EdisonGameModuleConfig.symbolController.changeSymbolState(<EdisonStateReelSymbol>symbol, EdisonGameConfig.instance.SYMBOL_STATES.gold);
                    } else if(symbol.symName === "M2" && this._gameData.randomM2WildModeTriggeredThisSpin) {
                        EdisonGameModuleConfig.symbolController.changeSymbolState(<EdisonStateReelSymbol>symbol, EdisonGameConfig.instance.SYMBOL_STATES.gold);
                    }
                }
            });
        }

    }
}